import { render, staticRenderFns } from "./ReservedSales.vue?vue&type=template&id=4132ca2a&scoped=true&"
import script from "./ReservedSales.vue?vue&type=script&lang=ts&"
export * from "./ReservedSales.vue?vue&type=script&lang=ts&"
import style0 from "./ReservedSales.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReservedSales.vue?vue&type=style&index=1&id=4132ca2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4132ca2a",
  null
  
)

export default component.exports